import styled from 'styled-components'
import { IconButton } from '@mui/material'

export const FAQDrawerPaper = styled.div`
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  min-height: 200px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
`

export const FAQDrawerHeader = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  gap: 16px;
  @media (min-width: 600px) {
    padding: 24px 28px 20px;
  }
`

export const FAQDrawerTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f1b24;
  letter-spacing: -0.02em;
  @media (min-width: 600px) {
    font-size: 1.4rem;
  }
`

export const FAQDrawerCloseBtn = styled(IconButton)`
  && {
    color: #5c5563;
    padding: 8px;
    &:hover {
      background: rgba(113, 84, 176, 0.08);
      color: #7154b0;
    }
  }
`

export const FAQDrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px 28px;
  @media (min-width: 600px) {
    padding: 20px 28px 32px;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(113, 84, 176, 0.25);
    border-radius: 3px;
  }
`

export const FAQCategoryBlock = styled.section`
  margin-bottom: 28px;
  &:last-child {
    margin-bottom: 0;
  }
`

export const FAQCategoryTitle = styled.h3`
  margin: 0 0 12px 0;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #7154b0;
  padding-bottom: 6px;
  border-bottom: 2px solid rgba(113, 84, 176, 0.2);
`

export const FAQAccordionWrap = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 10px;
  overflow: hidden;
  background: #faf9fc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    border-color: rgba(113, 84, 176, 0.2);
  }
`

export const FAQAccordionSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  cursor: pointer;
  min-height: 24px;
  transition: background 0.15s ease;

  .faq-question {
    flex: 1;
    font-size: 0.95rem;
    font-weight: 600;
    color: #1f1b24;
    line-height: 1.4;
    text-align: left;
  }
  .faq-expand-icon {
    flex-shrink: 0;
    color: #7154b0;
    transition: transform 0.2s ease;
    ${(props) => props.$expanded && 'transform: rotate(180deg);'}
  }
  &:hover {
    background: rgba(113, 84, 176, 0.06);
  }
`

export const FAQAccordionDetails = styled.div`
  padding: 0 16px 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);

  .faq-answer {
    padding-top: 12px;
    font-size: 0.9rem;
    font-weight: 400;
    color: #5c5563;
    line-height: 1.55;
  }
  .faq-answer p {
    margin: 0 0 8px 0;
  }
  .faq-answer p:last-child {
    margin-bottom: 0;
  }
  .faq-answer a {
    color: #7154b0;
    font-weight: 500;
    text-decoration: none;
  }
  .faq-answer a:hover {
    text-decoration: underline;
  }
`

export const FAQEmptyMessage = styled.p`
  margin: 0;
  padding: 40px 20px;
  text-align: center;
  font-size: 0.95rem;
  color: #8b8398;
`

export const FAQSpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;

  .faq-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(113, 84, 176, 0.2);
    border-top-color: #7154b0;
    border-radius: 50%;
    animation: faq-spin 0.8s linear infinite;
  }
  @keyframes faq-spin {
    to {
      transform: rotate(360deg);
    }
  }
`
